<template>
    <div>
        <img class="sizeMarker" src="@/assets/img/pin-green.png" alt="" srcset="">
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>